// Steps/Stepper.js

import { useLocation } from "react-router-dom";

export const Stepper = () => {
    const location = useLocation();
    let status = '';

    const getLinkClass = (path) => {
        if (path === location.pathname) {
            status = 'step-is-active';
        }
        return (
            (path === location.pathname ? "step-is-active" : '')
        );
    };

    return (
        <div className="row">
            {getLinkClass()}
            <div className="col-12">
                <div className="checkout__steps d-flex align-items-center justify-content-center">
                    <div className={getLinkClass("/") + ' checkout__steps__item'}>
                        <div className="checkout__steps__item-circle d-flex align-items-center justify-content-center">
                            <span>1</span>
                            <i className="fa-solid fa-check"></i>
                        </div>
                        <div className="checkout__steps__item-label">Stand kiezen</div>
                    </div>
                    <div className={getLinkClass("/gegevens") + ' checkout__steps__item'}>
                        <div className="checkout__steps__item-circle d-flex align-items-center justify-content-center">
                            <span>2</span>
                            <i className="fa-solid fa-check"></i>
                        </div>
                        <div className="checkout__steps__item-label">Gegevens</div>
                    </div>
                    <div className={getLinkClass("/samenvatting") + ' checkout__steps__item'}>
                        <div className="checkout__steps__item-circle d-flex align-items-center justify-content-center">
                            <span>3</span>
                            <i className="fa-solid fa-check"></i>
                        </div>
                        <div className="checkout__steps__item-label">Samenvatting</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
